export const CATEGORIES = {
	tasks: 'tasks',
	agents: 'agents',
	taskToCash: 'taskToCash',
}